<template>
    <div class="bg-secondary-accent border-y-4 border-accent ">
        <div class="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
            <div
                class="mx-auto
                max-w-76 mobile-lg:max-w-xs mobile-xl:max-w-lg tablet-sm:max-w-2xl tablet-lg:max-w-4xl laptop-lg:max-w-6xl desktop:max-w-7xl
                text-center
                py-4
                fancy-border border-secondary-accent border-16
                "
            >
                <h2
                    class="font-subtitle text-balance text-4xl font-semibold tracking-wide text-white sm:text-5xl"
                >Why Northeast Florida?</h2>
                <p
                    class="mx-auto mt-6 max-w-xs mobile-xl:max-w-xs tablet-sm:max-w-lg tablet-lg:max-w-2xl laptop-lg:max-w-4xl desktop:max-w-6xl text-pretty text-lg/8 text-white">From beachside living in Ponte Vedra to amenity driven neighborhoods like Julington Creek and Silverleaf, this area offers top-rated schools, golf communities, and unbeatable outdoor lifestyle. I’m here to help you find a home that fits your goals—whether you're relocating, downsizing, or buying your first home in St. Johns County.</p>
                <div class="mt-10 flex items-center justify-center gap-x-6">
                    <Link
                        :href="route('buying')"
                        preserve-state
                        @click="mobileMenuOpen = false"
                        class=" bg-white px-3.5 py-2.5 text-base font-semibold text-black shadow-sm hover:bg-secondary-accent hover:ring-white hover:ring-inset hover:ring-1 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray"
                    >Buy a Home in Northeast Florida</Link>
                    <Link
                        :href="route('home') + '#property-search'"
                        preserve-state
                        @click="mobileMenuOpen = false"
                        class="px-4 text-base font-semibold text-white hover:text-black hover:border-white hover:border-b"
                    >Explore the Area <ArrowRightIcon class="h-4 w-4 inline-block" /></Link>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { Link } from "@inertiajs/vue3";
import { ArrowRightIcon } from "@heroicons/vue/24/outline";

</script>
<style scoped>
.fancy-border {
    border-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='75' height='75'%3E%3Cg fill='none' stroke='%23748B75' stroke-width='2'%3E%3Cpath d='M1 1h73v73H1z'/%3E%3Cpath d='M8 8h59v59H8z'/%3E%3Cpath d='M8 8h16v16H8zM51 8h16v16H51zM51 51h16v16H51zM8 51h16v16H8z'/%3E%3C/g%3E%3Cg fill='%23748B75'%3E%3Ccircle cx='16' cy='16' r='2'/%3E%3Ccircle cx='59' cy='16' r='2'/%3E%3Ccircle cx='59' cy='59' r='2'/%3E%3Ccircle cx='16' cy='59' r='2'/%3E%3C/g%3E%3C/svg%3E") 25;
}

</style>
